import request from '@/utils/request';

export function GeneralCollectApi() {
    return{
        // 综合统计
        generalCollectList: params => {
            return request({
                url: '/admin/index/general_collect',
                method: 'get',
                params,
            });
        },
        //小说筛选列表
        getSelectMovie: params => {
            return request({
                url: '/admin/novel/select_novel_admin',
                method: 'get',
                params,
            });
        },

        //渠道筛选
        getSelectVip: params => {
            return request({
                url: '/admin/auth/vip/select',
                method: 'get',
                params,
            });
        },

        //优化师筛选
        getSelectOptimizer: params => {
            return request({
                url: '/admin/auth/optimizer/select',
                method: 'get',
                params,
            });
        },

        //渠道号筛选
        getSelectReferral: params => {
            return request({
                url: '/admin/referral/select',
                method: 'get',
                params,
            });
        },

        //综合统计渠道排行
        getChannelRanking: params => {
            return request({
                url: '/admin/index/statistics/channel_rankings_all',
                method: 'get',
                params,
            });
        },

        // 分账统计
        copyRightDataList: params => {
            return request({
                url: '/admin/index/copyright_data',
                method: 'get',
                params,
            });
        },
    }
}